import React from 'react'

import { ErrorIcon } from '@masfront/common-b2c'

import { Box, Typography } from '@material-ui/core'

interface ErrorMessageProps {
  title: string
  subtitle?: string
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ title, subtitle }) => {
  return (
    <Box display="flex" mt={10} justifyContent="center" alignItems="center" flexDirection="column">
      <Box mb={6}>
        <ErrorIcon />
      </Box>
      <Box mb={6}>
        <Typography variant="h2">{title}</Typography>
      </Box>
      {subtitle && (
        <Box mb={20}>
          <Typography variant="body1" color="textSecondary">
            {subtitle}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default ErrorMessage
